import { formatDateHuman } from "../date-utils";
import { formatValueHuman } from "../format-utils";
export const progettoAzioniGeneralDtoFields = [{
        name: "codiceCommessa",
        title: "Codice commessa",
        render: (record) => `<span style="max-width:20em;max-height: 2.3em;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">${record.codiceCommessa}</span>`
    }, {
        name: "stato",
        title: "Stato progetto",
        render: (record) => record.stato == null || record.stato == "" ? "" : `<span class="tag ${record.stato == 'Concluso' ? 'is-success' : 'is-info'}">${formatValueHuman(record.stato)}</span>`
    }, {
        name: "codiceProgetto",
        title: "Codice progetto",
        render: (record) => `<span style="max-width:20em;max-height: 2.3em;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">${formatValueHuman(record.codiceProgetto)}</span>`
    }, {
        name: "titolo",
        title: "Titolo",
        render: (record) => `<span style="width:35em;max-height: 2.3em;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">${record.titolo}</span>`
    }];
export const progettoAzioniDtoFields = [{
        name: "origin",
        title: "Origine",
        render: (record) => `<span style="max-width:20em;display:inline-block;">${record.origin}</span>`
    }, {
        name: "codiceazione",
        title: "Codice azione",
        render: (record) => `<span style="max-width:20em;display:inline-block;">${record.codiceAzione}</span>`
    }, {
        name: "desc",
        title: "Descrizione",
        render: (record) => `<span style="width:30em;max-height: 2.3em;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">${formatValueHuman(record.descrizioneAzione)}</span>`
    }, {
        name: "idfimam39",
        title: "ID FIMAA39",
        render: (record) => formatValueHuman(record.iDAzioneFIMAA39)
    }, {
        name: "riferimento",
        title: "Riferimento note",
        render: (record) => formatValueHuman(record.riferimentoNote)
    }, {
        name: "ore",
        title: "Ore",
        render: (record) => formatValueHuman(record.ore)
    }, {
        name: "oretipo",
        title: "Tipologia Ore",
        render: (record) => formatValueHuman(record.tipologiaOre)
    }, {
        name: "desctipo",
        title: "Desc. tipo intervento",
        render: (record) => formatValueHuman(record.descrTipoIntervento)
    }, {
        name: "uffcompetenza",
        title: "Uff Competenza",
        render: (record) => formatValueHuman(record.uffcompetenza)
    }, {
        name: "stato",
        title: "Stato azione",
        render: (record) => record.statoazione == null || record.statoazione == "" ? "" : `<span class="tag ${record.statoazione == 'Concluso' ? 'is-success' : 'is-info'}">${formatValueHuman(record.statoazione)}</span>`
    }, {
        name: "dataStato",
        title: "Data stato",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.dataStato)
    }, {
        name: "pianificato",
        title: "Pianificato",
        render: (record) => formatValueHuman(record.pianificato)
    }, {
        name: "erogato",
        title: "Erogato",
        render: (record) => formatValueHuman(record.erogato)
    }, {
        name: "annullato",
        title: "Annullato",
        render: (record) => formatValueHuman(record.annullato)
    }, {
        name: "dataInizio",
        title: "Data inizio",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.dataInizio)
    }, {
        name: "dataFine",
        title: "Data fine",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.dataFine)
    }, {
        name: "partecipantiAttesi",
        title: "Partecipanti Attesi",
        render: (record) => formatValueHuman(record.partecipantiAttesi)
    }, {
        name: "costoStandard1",
        title: "Costo Standard 1",
        render: (record) => formatValueHuman(record.costoStandard1)
    }, {
        name: "costoStandard2",
        title: "Costo Standard 2",
        render: (record) => formatValueHuman(record.costoStandard2)
    }, {
        name: "budget",
        title: "Budget",
        render: (record) => formatValueHuman(record.budget)
    }, {
        name: "monitoraggioEffettuato",
        title: "Monitoraggio Effettuato",
        render: (record) => formatValueHuman(record.monitoraggioEffettuato)
    }, {
        name: "oreFinali",
        title: "Ore Finali",
        render: (record) => formatValueHuman(record.oreFinali)
    }, {
        name: "partecipantiFinali",
        title: "Partecipanti Finali",
        render: (record) => formatValueHuman(record.partecipantiFinali)
    }, {
        name: "totalerendicontato",
        title: "Totale Rendicontato",
        render: (record) => formatValueHuman(record.totalerendicontato)
    }, {
        name: "tipoRendiconto",
        title: "Tipo Rendiconto",
        render: (record) => formatValueHuman(record.tipoRendiconto)
    }, {
        name: "decurtazione",
        title: "Decurtazione",
        render: (record) => formatValueHuman(record.decurtazione)
    }];
